import axios from '../../api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getTherapeuticList = createAsyncThunk('therapeuticList', async () => {
  const response = await axios.get('/therapeutics');
  return response.data;
});
